export enum FilterType {
  SELECT = 'select',
  CHECKBOX = 'checkbox',
}

export interface DiningFilters {
  id: number;
  title: string;
}

export interface IFilter {
  id: string | number;
  name: string;
  value?: DepartureTimeEnum;
}

export interface ActivityFilterDefault<T = string | number | boolean> {
  value: T;
  name?: string;
}

export interface ActivityFilter<T = string | number | boolean> extends ActivityFilterDefault<T> {
  enabled: boolean;
  selected: boolean;
}

export enum DepartureTimeEnum {
  MORNING = '06:00:00-11:59:00',
  AFTERNOON = '12:00:00-17:59:00',
  EVENING = '18:00:00-23:59:00',
}
